// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SelectSectionPage_wrapper__2tmZs"};